import { modelName } from '@common/lib/model-name'

export const slicePrefix = modelName('entity')
